import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import logger from 'redux-logger';
import thunk from 'redux-thunk';
import { createHashHistory } from 'history';
import { Route } from 'react-router';
import { ConnectedRouter, routerMiddleware } from 'react-router-redux';
import { muteToastMiddleWare } from './middleware/muteToasts';

import registerServiceWorker from './registerServiceWorker';
import reducer from './reducers';
import Analytics from './helpers/analytics';
import { signalRHubManager } from './actions/signalRHub/signalRHubManager';

import PageComponent from './Components/PageComponent';
import PRTGComponent from './Components/PRTGComponent';

import AcquisitionContainer from './Containers/AcquisitionContainer';
import ArtifactHealthContainer from './Containers/ArtifactHealthContainer';
import BuildContainer from './Containers/BuildContainer';
import BuildHealthContainer from './Containers/BuildHealthContainer';
import CloudContainer from './Containers/CloudContainer';
import InstallerTestsContainer from './Containers/InstallerTestsContainer';
import MetricsContainer from './Containers/MetricsContainer';
import NodeHealthContainer from './Containers/NodeHealthContainer';
import PerformanceTypeSelectorContainer
  from './Containers/PerformanceTypeSelectorContainer';
import ProfileContainer from './Containers/ProfileContainer';
import RegressionContainer from './Containers/RegressionContainer';
import ReleaseMetricsContainer from './Containers/ReleaseMetricsContainer';
import AWSInstancesCostContainer from './Containers/AWSInstancesCostContainer';
import TelemetryContainer from './Containers/TelemetryContainer';

import reduxReset from 'redux-reset';
import { USER_KEY } from './helpers/storage';
import { auth } from './helpers';
import { fetchUserConfiguration } from './actions/profile';
import { performStartupSsoSignOn } from './actions/auth';
import { getUserConfiguration } from './reducers/profile';

// XXX: Can go back to browser history once old is gone
const history = createHashHistory();

if (process.env.NODE_ENV === 'production') {
  Analytics.Initialize();
  Analytics.LogPageView(history.location);
  history.listen(location => {
    Analytics.LogPageView(location);
  });
}

const middleware = [thunk, routerMiddleware(history), muteToastMiddleWare];
let composeEnhancers = compose;
if (process.env.NODE_ENV !== 'production') {
  middleware.push(logger);

  if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({});
  }
}
//required for usage of the redux-reset library
const enhancer = composeEnhancers(applyMiddleware(...middleware), reduxReset());
const store = createStore(reducer, enhancer);

// behind the AWS load balancer the user is already signed in through single sign-on
store.dispatch(performStartupSsoSignOn());

if (auth.checkAuthenticated()) {
  const username = localStorage.getItem(USER_KEY);
  store.dispatch(fetchUserConfiguration(username)).then(() => loadThemeStyling(store));
} else
  loadThemeStyling(store);

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <PageComponent>
        <Route path="/acquisition" component={AcquisitionContainer} />
        <Route path="/artifact-health" component={ArtifactHealthContainer} />
        <Route path="/artifacts-metrics" component={MetricsContainer} />
        <Route path="/artifact-regression" component={RegressionContainer} />
        <Route path="/build" component={BuildContainer} />
        <Route path="/build-health" component={BuildHealthContainer} />
        <Route path="/case-amending" component={RegressionContainer} />
        <Route path="/case-amending-performance" component={MetricsContainer} />
        <Route path="/case-amending-kpp-performance" component={MetricsContainer} />
        <Route path="/job-benchmark-performance" component={MetricsContainer} />
        <Route path="/case-metrics" component={MetricsContainer} />
        <Route path="/cloud" component={CloudContainer} />
        <Route path="/diff" component={RegressionContainer} />
        <Route path="/engine-metrics" component={MetricsContainer} />
        <Route path="/export-performance" component={MetricsContainer} />
        <Route path="/export-regression" component={RegressionContainer} />
        <Route path="/installer" component={InstallerTestsContainer} />
        <Route path="/node-health" component={NodeHealthContainer} />
        <Route path="/performance" component={PerformanceTypeSelectorContainer} />
        <Route path="/performance-metrics" component={MetricsContainer} />
        <Route path="/profile" component={ProfileContainer} />
        <Route path="/release-metrics" component={ReleaseMetricsContainer} />
        <Route path="/white" component={RegressionContainer} />
        <Route path="/aws-instances-cost" component={AWSInstancesCostContainer} />
        <Route path="/case-merging" component={RegressionContainer} />
        <Route path="/telemetry-process" component={TelemetryContainer} />
        <Route path="/telemetry-examine" component={TelemetryContainer} />
        <Route path="/telemetry-axiom-scans-today" component={TelemetryContainer} />
        <Route path="/artifact-stats" component={TelemetryContainer} />
        <Route path="/jira-metrics" component={TelemetryContainer} />
        <Route path="/test-studio" component={RegressionContainer} />
        <Route path="/remote-acquire-regression" component={RegressionContainer} />
        <Route path="/prtg" component={PRTGComponent} />
        <Route path="/axiom-ui" component={RegressionContainer} />
      </PageComponent>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
);

registerServiceWorker();

window.onbeforeunload = () => {
  signalRHubManager.clearAndStop();
};

function loadThemeStyling(store) {
  if (getUserConfiguration(store.getState()).darkMode)
    require('./styles/dark.scss');

  else
    require('./styles/index.scss');

}


// WEBPACK FOOTER //
// src/index.js